<template>
  <div class="evolution-chain" :class="{'group':chain.length > 1 && (chain.length < 4 || checkChildrenHasNext(chain))}">
    <template v-for="(e, i) in chain">
      <div class="evolution-group" v-if="chain.length > 1" :key="i + '-group'">
        <evolution :pokemon="e" :key="i + '-evolution'"></evolution>
        <template class="icon reset" v-if="e.next">
          <i class="next mdi mdi-arrow-right-thick" :key="i + '-next'"></i>
          <evolution-chain :chain="e.next" :key="i + '-chain'" :class="{'multi': e.next && e.next.length > 1}"></evolution-chain>
        </template>
      </div>
      <template v-else>
        <evolution :pokemon="e" :key="i + '-evolution'"></evolution>
        <template class="icon reset" v-if="e.next">
          <i class="next mdi mdi-arrow-right-thick" :key="i + '-next'"></i>
          <evolution-chain :chain="e.next" :class="{'multi': e.next && e.next.length > 1}" :key="i + '-chain'"></evolution-chain>
        </template>
      </template>
    </template>
  </div>
</template>


<script>
import Evolution from './Evolution'

export default {
  name: 'evolution-chain',
  props: ['chain'],
  components: {
    Evolution
  },
  methods: {
    checkChildrenHasNext(chain) {
      for (let i in chain) {
        if (chain[i].next && chain[i].next.length > 1) {
          return true
        }
      }
      return false
    }
  }
}
</script>
